import { render } from "./BtnBackUl.vue?vue&type=template&id=2ec2d20e"
import script from "./BtnBackUl.vue?vue&type=script&lang=js"
export * from "./BtnBackUl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__